// extracted by mini-css-extract-plugin
module.exports = {"google-button":"styles__google-button___3__mc","icon":"styles__icon___2SMHn","disabled":"styles__disabled___2fIO-"};